import { customHeaders, requestApi } from 'api/api'
import { RestApi } from '@node-space/rest-api'
import { Channel } from 'types/channels'
import { EditChannelReq, GetChannelsReq } from 'types/transaction/GetChannelsReq'
import { isTestEnvironment } from 'utils/utils'

export const getChannels = async ({ offset, max, merchant, search }: GetChannelsReq) => {
  const merchantParam = merchant && merchant !== 'ALL' ? `&merchantId=${merchant}` : ''
  const referenceString = search ? `&q=${encodeURI(search)}` : ''
  const getParams = `?max=${max}&offset=${offset}${merchantParam}${referenceString}`
  const { data, headers }: { data: Channel[]; headers: { [key: string]: string } } =
    await RestApi.get(!isTestEnvironment, `v2/channel${getParams}`, null, null, customHeaders)

  return {
    channels: data || [],
    paging: {
      total: Number(headers['x-api-list-total']),
      offset: Number(headers['x-api-list-start']),
      max,
    },
  }
}
export const createChannel = async ({ merchantId, payCurrency, displayCurrency, reference }) => {
  const { data } = await RestApi.post(
    !isTestEnvironment,
    'v2/channel',
    {
      merchantId,
      payCurrency,
      displayCurrency,
      reference,
    },
    customHeaders
  )

  return data
}

export const editChannel = async ({ merchantId, reference, uuid }: EditChannelReq) => {
  return requestApi({
    url: '/v2/channel',
    method: 'PUT',
    data: { merchantId, reference, uuid },
  })
}
